<template>
  <v-card shaped>
    <v-card-title>
      {{ session.fields.Name }}
    </v-card-title>
    <v-card-text>
      <v-row v-if="session.fields.Description" class="d-flex justify-space-between">
        <v-col>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-text</v-icon>
            <strong>Description</strong>
          </div>
          <div>
            {{ 
               this.session.fields.Description ? 
               this.session.fields.Description : '' 
             }}
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-space-between">
        <v-col>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
            <strong>Location</strong>
          </div>
          <div>
            {{ 
               this.session.fields.Location ? 
               this.session.fields.Location : 'TBD' 
             }}
          </div>
        </v-col>
        <v-col>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-video-outline</v-icon>
            <strong>Video Link</strong>
          </div>
          <div>
            {{ 
               this.session.fields['Video Share Link'] ? 
               this.session.fields['Video Share Link'] : 'None' 
             }}
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-space-between">
        <v-col>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-clock-outline</v-icon>
            <strong>Start</strong>
          </div>
          <div>
            {{ formatDatetime(session.fields.Start) }}
          </div>
        </v-col>
        <v-col>
          <div class="d-flex align-center">
            <v-icon small class="mr-1">mdi-clock-outline</v-icon>
            <strong>End</strong>
          </div>
          <div>
            {{ formatDatetime(session.fields.End) }}
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <SessionSignUpButton :session="session" />
    </v-card-actions>
  </v-card>
</template>

<script>
  // import moment from 'moment'
  import SessionSignUpButton from '@/components/session/SignUpButton'
  
  export default {
    name: 'SessionSignupCard',
    props: {
      session: Object
    },
    components: {
      SessionSignUpButton
    },
    methods: {
      formatDatetime (date) {
        if (!date) { return 'TBD' }
        const dt = new Date(date);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' };
        return new Intl.DateTimeFormat('default', options).format(dt);
      }
    }
  }
</script>
